import * as React from 'react';
export const docusignSvg = React.forwardRef(function docusignSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D6FB00',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M23.615 13.4 16 20.96 8.385 13.4l2.335-2.318 3.588 3.553V5h3.384v9.635l3.58-3.562 2.343 2.327ZM5 26h22v-3.36H5V26Z',
      fill: '#000',
    }),
  );
});
docusignSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var docusign = {
  category: 'brand',
  colorable: false,
  name: 'docusign',
  svg: docusignSvg,
};
